import {keepPreviousData} from "@tanstack/react-query";
import {useCustomQuery} from "../../../query/queryClient";
import {queryHttp} from "../../../query/queryHttp";
import type {PageResponse} from "../../../services/ApiTypes";
import {supplierEntityListUrl} from "../services/supplier360Urls";
import type {SupplierEntity, SupplierEntityListParams} from "../types/Supplier360Types";

/**
 * Paginated Supplier 360 registry list (`GET supplier_360/entity/`).
 */
export function useSupplierEntitiesQuery(
    databagId: number,
    params: SupplierEntityListParams,
    options: {enabled?: boolean} = {},
) {
    const {enabled = true} = options;
    return useCustomQuery({
        queryKey: [supplierEntityListUrl(databagId, params)] as const,
        queryFn: async () => (await queryHttp.get<PageResponse<SupplierEntity>>(supplierEntityListUrl(databagId, params))).data,
        enabled: enabled && Boolean(databagId),
        placeholderData: keepPreviousData,
        showErrorNotification: true,
    });
}
